import React from 'react';
import Renderer from '../renderer';
import Button from '../Button';
import { Popover } from '@mui/material';
import { Info } from '@phosphor-icons/react/dist/ssr';
import { makeStyles } from "tss-react/mui";
import quizInfoImage from "../../assets/images/quiz/info.svg"

const useStyles = makeStyles()((theme, { pointerPosition }) => ({
    actionButton: {
        marginTop: '-10px',
        marginTop: 'auto',
        marginBottom: 'auto',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        transition: 'transform 0.1s ease, box-shadow 0.1s ease',
        '&:disabled': {
            opacity: 0.5,
            cursor: 'not-allowed',
        },
        '&:not(:disabled):active': {
            transform: 'scale(0.95)',
        },
    },
    buttonImage: {
        width: '40px',        // Fixed image size
        height: '40px',       // Fixed image size
        objectFit: 'contain',
    },
    popover: {
        padding: '8px',
        backgroundColor: 'transparent'
    },
    popoverContent: {
        padding: '10px 20px',
        borderRadius: '30px',
        border: '2px solid rgba(105, 207, 255, 1)', // Light blue border color
        backgroundColor: '#fff',
        boxShadow: '2px 2px 4px 0px rgba(0, 0, 0, 0.25)',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '-12px',
            left: pointerPosition, // Centers the triangle
            width: 0,
            height: 0,
            borderLeft: '12px solid transparent',
            borderRight: '12px solid transparent',
            borderBottom: '12px solid rgba(105, 207, 255, 1)', // Triangle color
        },
    },
}));

export default function HelpText({ data, style = {} }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [pointerPosition, setPointerPosition] = React.useState('10%');

    const popoverRef = React.useRef(null);

    const { classes } = useStyles({ pointerPosition });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        const buttonRect = event.currentTarget.getBoundingClientRect();

        const popoverRect = popoverRef.current?.getBoundingClientRect();
        if (popoverRect) {
            const pointerLeft = ((buttonRect.left + buttonRect.width / 2) - popoverRect.left) / popoverRect.width * 100;
            setPointerPosition(`${pointerLeft}%`);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    if (!data || (!data.text && !data.contentURL && !data.overrideHTML)) {
        return null;
    }

    return (
        <div style={{ display: 'flex', ...style }}>
            {/* <Button aria-describedby={id} onClick={handleClick} style={styles.button} type={'tertiary'} placeholder={<Info size={24}/>} /> */}
            <button
                className={classes.actionButton}
                aria-describedby={id} onClick={handleClick}
            >
                <img className={classes.buttonImage} src={quizInfoImage} />
            </button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                className={classes.popover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    style: {
                        overflow: 'visible',
                        background: 'transparent',
                        boxShadow: 'none',
                        paddingTop: '.5rem',
                        marginLeft: '-1rem',
                    },
                }}
                ref={popoverRef}
                disablePortal
            >

                <div className={classes.popoverContent}>
                    {/* {data.text} */}
                    <Renderer content={data?.text || data}
                        mediaStyle={{}}
                        // style={{ padding: '.85rem' }}
                        contentUrl={data?.contentURL}
                        contentType={data?.style}
                        overrideHTML={data?.overrideHTML}
                        templateType={data?.displayTemplate}
                    />
                </div>
            </Popover>
        </div>

    );
}